@if (initialized() && carouselItems().length > 0) {
  <div class="carousel-container">
    @switch (carouselType()) {
      @case ("authors") {
        <div
          class="swiper-container my-4 fade-in"
          (animationend)="handleSwiper()"
        >
          <swiper-container
            class="swiper-container-custom"
            #swiper
            init="false"
          >
            @for (item of carouselItems(); track $index) {
              <swiper-slide class="author-card pb-5">
                <div class="card bg-light">
                  <div class="card-body">
                    <div>
                      <a [routerLink]="['/buscar']"
                      [queryParams]="{ a: item?.id }">
                      <img
                        [src]="item.photo | assetFormatter"
                        class="rounded-circle border border-2"
                        width="70"
                        height="70"
                        [alt]="item.name"
                      />
                    </a>
                    </div>

                    <div class="my-auto">
                      <p class="h5 mb-0">
                        {{ item.name + " " + item.surname }}
                      </p>
                    </div>

                    <div class="my-auto">
                      <a class="btn btn-light btn-sm" [routerLink]="['/buscar']"
                      [queryParams]="{ a: item?.id }"
                      >
                        Ver artículos
                      </a>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            }
          </swiper-container>
        </div>
      }

      @case ("hindsight") {
        <div
          class="swiper-container my-4 fade-in"
          (animationend)="handleSwiper()"
        >
          <swiper-container
            class="swiper-container-custom"
            #swiper
            init="false"
          >
            @for (item of carouselItems(); track $index) {
              <swiper-slide class="retrospective-card pb-5">
                <div class="d-flex flex-column px-1 px-md-2">
                  <a
                    [routerLink]="['/articulo', item.slug]"
                    class="retrospective-image d-block mb-3"
                  >
                    <img
                      [src]="item.image | assetFormatter"
                      class="img-zoomable"
                      [alt]="item.title"
                    />
                  </a>

                  @if (item.subject) {
                    <div>
                      <div class="category-badge-sm mb-2">
                        {{ item.subject?.name }}
                      </div>
                    </div>
                  }

                  <h4 class="mb-0 pt-2 h5">
                    <a [routerLink]="['/articulo', item.slug]">
                      {{ item.title }}
                    </a>
                  </h4>

                  @if (item.author) {
                    <a
                      class="author-label mt-2"
                      [routerLink]="['/buscar']"
                      [queryParams]="{ a: item.author?.id }"
                    >
                      Por {{ item.author?.name + " " + item.author?.surname }}
                    </a>
                  }
                </div>
              </swiper-slide>
            }
          </swiper-container>
        </div>
      }

      @case ("tags") {
        <div
          class="swiper-container my-4 fade-in"
          (animationend)="handleSwiper()"
        >
          <swiper-container
            class="swiper-container-custom"
            #swiper
            init="false"
          >
            @for (item of carouselItems(); track $index) {
              <swiper-slide class="pb-5">
                <div
                  class="tag-card d-flex"
                  [style.background-image]="
                    'url(' + (item.image | assetFormatter) + ')'
                  "
                >
                  <div class="align-self-end tag-card-content w-100 p-3">
                    <h5 class="tag-name"># {{ item.name }}</h5>

                    <a
                      class="btn btn-link text-white text-decoration-none fw-lighter"
                      [routerLink]="['/buscar']"
                      [queryParams]="{ t: item.name }"
                    >
                      Ver artículos
                    </a>
                  </div>
                </div>
              </swiper-slide>
            }
          </swiper-container>
        </div>
      }

      @case ("videos")
      @case ("videos-detail")
      
      {
        <div
          class="swiper-container my-4 fade-in"
          (animationend)="handleSwiper()"
        >
          <swiper-container
            class="swiper-container-custom"
            #swiper
            init="false"
          >
            @for (item of carouselItems(); track $index) {
              <swiper-slide class="pb-5">
                <div class="video-card">
                  <a
                    [routerLink]="['/articulo', item.slug]"
                    class="home-video-image d-block"
                    [ngClass]="{'video-detail': carouselType() === 'videos-detail'}"
                  >
                    <img
                      [src]="item.cover | assetFormatter"
                      class="img-zoomable"
                      [alt]="item.title"
                    />
                  </a>

                  <h3 class="h5 mt-2">
                    <a [routerLink]="['/articulo', item.slug]">
                      {{ item.title }}
                    </a>
                  </h3>
                </div>
              </swiper-slide>
            }
          </swiper-container>
        </div>
      }

      @case ("interest") {
        <div
          class="swiper-container my-4 fade-in"
          (animationend)="handleSwiper()"
        >
          <swiper-container
            class="swiper-container-custom"
            #swiper
            init="false"
          >
            @for (item of carouselItems(); track $index) {
              <swiper-slide class="pb-5">
                <div class="d-flex flex-column">
                  <div class="related-image d-block">
                    <img
                      [src]="item.image | assetFormatter"
                      class="img-zoomable"
                      [alt]="item.title"
                    />
                  </div>

                  <p class="h5 mt-2">
                    <a [routerLink]="['/articulo', item.slug]">
                      {{ item.title }}
                    </a>
                  </p>

                  @if (item.subtitle) {
                    <p class="mb-2">
                      {{ item.subtitle }}
                    </p>
                  }

                  @if (item.meta_description) {
                    @if (item.meta_description.length > 130) {
                      <div
                        [innerHTML]="
                          item.meta_description.slice(0, 130) + '...'
                        "
                      ></div>
                    } @else {
                      <div [innerHTML]="item.meta_description"></div>
                    }
                  }

                  @if (item.author) {
                    <a
                      class="author-label d-block"
                      [routerLink]="['/buscar']"
                      [queryParams]="{ a: item.author?.id }"
                    >
                      <span class="fw-bold">
                        Por {{ item.author.name + " " + item.author.surname }}
                      </span>
                    </a>
                  }
                </div>
              </swiper-slide>
            }
          </swiper-container>
        </div>
      }
    }
  </div>
}
